export const CREATE_INDEX_WORKER_NAME = "create_index_worker";
export const CREATE_INDEX_WORKER_DESC = `Creates an Index Worker with the same configurable fields as the IW GUI form.

This tool mirrors the GUI behavior:
- It calls createIndexWorker.
- If schedule.type is 'run-once', it additionally calls runIndexWorker to execute immediately (no schedule is stored).

Input (high level):
- 'organizationId' (required): Workspace/Organization ID.
- 'projectId' or 'projectName': Target Index Worker project.
- 'name' (required): Index Worker display name.
- 'note' (optional): Description/note.
- 'propertyId' (required to execute): Search Console property ID selected by the user.
- 'urlType' (required): 'SITEMAP' | 'RSS' | 'MANUAL'.
- 'samplingCount' (optional): 1..2000 (default 500).
- 'schedule' (optional): one of 'not-set' | 'run-once' | 'daily' | 'weekly' | 'custom'. Defaults to 'not-set' when omitted.
- URL source fields (depending on urlType):
  - SITEMAP: 'sitemap' (optional at draft time; can be selected in confirmation UI)
  - RSS: 'rssFeed' + 'rssFeedSamplingPeriod' (allowed values: 1, 3, 7, 28, 365, 0=all time)
  - MANUAL (手動入力 / CSVアップロード): 'urls' (optional at draft time; can be filled in confirmation UI)
- Optional filters:
  - 'urlGroup'
  - 'ignoreURLParameters'

Required workflow:
- Confirm target project first (ask user if ambiguous).
- Let create_index_worker return property candidates when propertyId is missing.
- Ask the user to choose one candidate, then pass the selected 'propertyId'.
- If urlType is SITEMAP and sitemap is missing at execution time, create_index_worker may return sitemap candidates in guidance. In pre-question phase, sitemap can be omitted and set in confirmation UI.
- Do not execute this tool without both project and propertyId fixed.

Draft policy (chat + confirmation UI):
- Prefer a minimum pre-question set: project, name, source type, property choice, and source value only when required (RSS).
- Do not block on optional fields (note, urlGroup, ignoreURLParameters, samplingCount, detailed schedule) before the tool call.
- Let confirmation UI handle optional tuning; if the user already specified optional values, include them in draft input.

Notes:
- This performs write operations (mutations) and requires explicit approval via Confirmation UI.
- Returns navigation links for follow-up: 'projectPath'/'projectUrl' and 'indexWorkerPath'/'indexWorkerUrl'.
- For RSS source, sampling period is a fixed enum-like set: 1, 3, 7, 28, 365, or 0 (all time). Do not treat it as an arbitrary N-day value.
- For 'weekly' schedule, if dayOfWeek is omitted it defaults to "today" in the server environment.
- Confirmation UI can override drafted input before execution.`;
